<template>
  <section class="produto-varejo-inteligente-formulario">
    <div class="content">
      <Titulo
        title="Dados do Evento"
        description="Informe os dados necessários para a reserva."
      />
      <FormulateForm name="Cadastro" v-model="values" @submit="salvar">
        <div class="mt-1 form-wrap px-4 pb-4">
          <div class="row">
            <div class="col-md-8 mt-4">
              <FormulateInput
                type="text"
                name="evento"
                label="Nome do evento"
                validation="required"
              />
            </div>
            <div class="col-md-4 mt-4">
              <FormulateInput
                type="number"
                name="pessoas"
                label="Quantidade de pessoas"
                :validation="`required|max:${maxCapacidade}`"
                :max="maxCapacidade"
              />
            </div>
          </div>
          <div class="row">
            <div class="col mt-4">
              <FormulateInput
                name="aguacafe"
                :options="{
                  true: 'Sim',
                  false: 'Não',
                }"
                type="radio"
                label="Água e Café"
              />
            </div>
            <div class="col mt-4">
              <FormulateInput
                name="coffeexterno"
                :options="{
                  true: 'Sim',
                  false: 'Não',
                }"
                type="radio"
                label="Coffe Externo"
              />
            </div>
            <div class="col mt-4" v-if="tipoProduto == 'rooftop'">
              <FormulateInput
                name="projetor"
                :options="{
                  true: 'Sim',
                  false: 'Não',
                }"
                type="radio"
                label="Projetor"
              />
            </div>
            <div class="col mt-4" v-if="tipoProduto == 'rooftop'">
              <FormulateInput
                name="telao"
                :options="{
                  true: 'Sim',
                  false: 'Não',
                }"
                type="radio"
                label="Telão"
              />
            </div>
            <div class="col mt-4" v-if="tipoProduto == 'rooftop'">
              <FormulateInput
                name="som"
                :options="{
                  true: 'Sim',
                  false: 'Não',
                }"
                type="radio"
                label="Som"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-4">
              <FormulateInput
                name="responsavel"
                type="text"
                label="Nome do responsável"
                validation="required"
              />
            </div>
            <div class="col-md-3 mt-4">
              <FormulateInput
                name="telefone"
                type="text"
                validation="required"
                v-mask="'(##) #####-####'"
                label="Telefone de contato"
              />
            </div>
            <div class="col-md-3 mt-4">
              <FormulateInput
                name="email"
                type="email"
                validation="required|email"
                label="E-mail de contato"
              />
            </div>
          </div>
        </div>
        <div class="row mt-5 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
            <Botao
              title="Voltar"
              link="/produto/cdl-varejo-inteligente/produtos"
              nameClass="btn btn-outline-secondary btn-lg btn-block"
              >VOLTAR</Botao
            >
          </div>
          <div class="col-md-4 col-lg-2">
            <Botao
              title="Próximo"
              @click="validar"
              nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
              >PRÓXIMO</Botao
            >
          </div>
        </div>
      </FormulateForm>
    </div>
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
export default {
  name: "CdlSaude",
  components: { Titulo, Botao },
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDL Varejo Inteligente",
      },
      values: {},
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente/produtos",
        },
        {
          nome: "Formulário",
          id: "formulario",
          produto: "CDL Varejo Inteligente",
        },
      ],
      produtos: [
        {
          nome: "Sala de Reunião",
          link: "reuniao",
        },
        {
          nome: "Mini-Auditório",
          link: "Auditório",
        },
        {
          nome: "RoofTop",
          link: "Rooftop",
        },
        {
          nome: "Estação de Trabalho",
          link: "estacao-trabalho",
        },
        {
          nome: "Escritório Virtual",
          link: "escritorio-virtual",
        },
      ],
      maxCapacidade: null,
      tipoProduto: null,
    };
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  methods: {
    montarDados() {
      if (sessionStorage.getItem("reserva")) {
        const session = JSON.parse(sessionStorage.getItem("reserva"));
        this.values = session.dadosReserva;
      }
    },
    validar() {
      this.$formulate.submit("Cadastro");
    },
    salvar() {
      const dadosReserva = {
        tipoReserva: this.urlParams.tipoProduto,
        dadosReserva: this.values,
        idAgenda: this.urlParams.idAgenda,
      };
      sessionStorage.setItem("reserva", JSON.stringify(dadosReserva));
      this.$router.push({ name: "agenda" });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    const session = JSON.parse(sessionStorage.getItem("valoresProdutos"));
    const produto = session.filter(
      (el) => el.agendaId == this.urlParams.idAgenda
    );
    this.maxCapacidade = produto[0].capacidade;
    this.tipoProduto = this.urlParams.tipoProduto;
    this.montarDados();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.produto-varejo-inteligente-formulario /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  input {
    padding: 5px 7px;
  }
  .formulate-input[data-type="radio"] {
    .formulate-input-element {
      display: flex;
      .formulate-input {
        margin-right: 7px;
        label {
          margin-left: 2px;
        }
      }
    }
  }
  .form-wrap {
    background: $dark-100;
    border-radius: 6px;
  }
}
</style>
